// src/components/store/sections/newsletter/NewsletterV66PostcardstampRoyalViolet.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV66PostcardstampRoyalViolet(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={66}
      archKey="postcard_stamp"
      archLabel="Vintage Postcard Stamp"
      palName="RoyalViolet"
      grad="from-violet-600 via-purple-600 to-indigo-700"
      lightBg="bg-violet-50"
      textCol="text-violet-700"
      borderCol="border-violet-200"
      btnCls="bg-violet-600 hover:bg-violet-700"
      hexCol="#8b5cf6"
      {...props}
    />
  );
}
